import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JWTService } from './JWTService';
import { Store } from '@ngrx/store';
import { HTTT, HoaDon, TTHD, HTTTs, HD, HDHuy, CTHoaDon, FormatSoTien, VATCount, dsVAT } from '../models/bill.model';
import { ServerResponse, TPCloud_isNumber, catChuoi, TPCloud_getFormatDate } from '../models/types';
import { Result } from '@zxing/library';
import { element } from 'protractor';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from './getLocalForage.service';
import { async } from 'q';
import { KhachHang } from '../models/customer.model';
import { KhachHangEinvoice } from '../models/einvoice.model';
import { NhanVien } from '../models/employees.model';

@Injectable()
export class EinvoiceService {
  url: any;
  constructor(
    private http: HttpClient,
    private jwtService: JWTService,
    private storeHTTT: Store<HTTT>,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
   
    }  

  async setEinvoice(bill: HoaDon, payments: Array<TTHD>, buyer: KhachHangEinvoice) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    payments.forEach(x => {
      const data: HTTTs = {
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenNhom: x.HTTT.TenNhom,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        DoUuTien: x.HTTT.DoUuTien,
        MaThe: x.HTTT.MaThe,
        SoTienThanhToanHD: x.SoTienThanhToanHD,
        QuyDoiNgoaiTe: x.QuyDoiNgoaiTe,
        TyLeQuyDoi: x.TyLeQuyDoi
      };
      list.push(data);
    });
    const bills: HD = {
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TongTienCK: bill.TienCK,
      TienTraKhach: bill.TienTraKhach
    };
    // const wrH: WrapHD = {
    //  Wraped: bills
    // };
    //const arry: HD[] = [];
    //arry.push(bills);
    //const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    //if (getDSHD !== null) {
    //  const dsHD = getDSHD;
    //  console.log('dsHD');
    //  console.log(dsHD);
    //  const deCryptDSHD = this.jwtService.deCryptData(dsHD);
    //  const listBills = JSON.parse(deCryptDSHD);
    //  const HDs: Array<HD> = listBills;
    //  // console.log(`*****Bill Thanh Toan*****`);
    //  // console.log(dsHD);
    //  // console.log(deCryptDSHD);
    //  // console.log(listBills);
    //  // console.log(listBillss);
    //  // console.log(`**********`);
    //  HDs.push(bills);
    //  const mahoaHoaDon = this.jwtService.enCryptData(HDs);
    //  this.getlocalconfig.getConfigLocalForage()
    //    .then(async result => {
    //      await localForage.setItem('_dsHD', mahoaHoaDon);
    //    });
    //  // console.log('HD');
    //  // console.log(HDs);
    //} else {
    //  const mahoaHoaDon = this.jwtService.enCryptData(arry);
    //  this.getlocalconfig.getConfigLocalForage()
    //    .then(async result => {
    //      await localForage.setItem('_dsHD', mahoaHoaDon);
    //    });
    //}
    return this.http.post(this.url + 'api/Einvoice/setEinvoice', {
      HoaDon: bills,
      KhachHangEinvoice: buyer,
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }

  async setEinvoice_HD(bill: HD, buyer: KhachHangEinvoice) {
    //let getState: NhanVien = new NhanVien();
    const cuaHang: NhanVien = JSON.parse(localStorage.getItem('_dtQBan'));
    //await localForage.getItem('_user').then((result: any) => {
    //  if (result) {
    //    getState = JSON.parse(result);
    //  }
    //});
    const bills: HD = {
      MaCH: cuaHang[0].MaCH,
      CTHoaDon: bill.CTHoaDon,
      HTThanhToan: bill.HTThanhToan,
      HoaDonId: bill.HoaDonId,
      MaKHTV: bill.MaKHTV,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TongTienCK: bill.TongTienCK,
      TienTraKhach: bill.TienTraKhach
    };
    return await this.http.post(this.url + 'api/Einvoice/setEinvoice', {
      HoaDon: bills,
      MaCH: cuaHang[0].MaCH,
      KhachHangEinvoice: buyer,
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }


  async setEinvoice_HD_GopThue(bill: HD, buyer: KhachHangEinvoice) {
    //let getState: NhanVien = new NhanVien();
    const cuaHang: NhanVien = JSON.parse(localStorage.getItem('_dtQBan'));
    //await localForage.getItem('_user').then((result: any) => {
    //  if (result) {
    //    getState = JSON.parse(result);
    //  }
    //});
    const bills: HD = {
      MaCH: cuaHang[0].MaCH,
      CTHoaDon: bill.CTHoaDon,
      HTThanhToan: bill.HTThanhToan,
      HoaDonId: bill.HoaDonId,
      MaKHTV: bill.MaKHTV,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TongTienCK: bill.TongTienCK,
      TienTraKhach: bill.TienTraKhach
    };
    return await this.http.post(this.url + 'api/Einvoice/setEinvoice_GopThue', {
      HoaDon: bills,
      MaCH: cuaHang[0].MaCH,
      KhachHangEinvoice: buyer,
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }

  async getTPC_Einvoice(value: string) {
    return this.http.post(this.url + 'api/Einvoice/get_einvoice', { MaHD: value })
      .toPromise()
      .then(result => result[0]);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/einvoice.service.ts